import request from "./request";
import { apiRequest } from "./apirequest";


export const getCountryList = () => apiRequest({ endpoint: "/settings/countries" });
export const getStateList = (countryID) => apiRequest({ endpoint: `/settings/states/${countryID}` });
export const getCityList = (stateID) => apiRequest({ endpoint: `/settings/cities/${stateID}` });


export const getCorporateList  = () => apiRequest({ endpoint: "/corporate" });
export const getFilterCategoryList = async ({
    pid = null, // Default to null if not provided
    page = 1, // Default to 1 for pagination
    searchQuery = "", // Default empty search
    selectedStatus = "", // Default empty status
    selectedCorporate = undefined, // Default undefined (won't be included in URL)
  } = {}) => {
    let endpoint = "/master?";
  
    if (pid) {
      endpoint += `parent_id=${pid}`;
    } else {
      endpoint += `type=filter_category`;
    }
  
    endpoint += `&page=${page}&searchText=${searchQuery}&status=${selectedStatus}`;
  
    if (selectedCorporate !== undefined) {
      endpoint += `&corporate_id=${selectedCorporate}`;
    }
  
    return apiRequest({ endpoint, method: "GET" });
  };
  

  export const getstatusList = () => apiRequest({endpoint: "/settings/charger/status"});
  export const updateCategoryStatus = async (CategoryId, status) => {
    return apiRequest({
      endpoint: `/master/change-status/${CategoryId}`,
      method: "PUT",
      data: { status },
    });
  };

  export const addFilterCategory = async (formData) => {
    return apiRequest({
      endpoint: "/master/",
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  export const updateFilterCategory = async (categoryId, formData) => {
    return apiRequest({
      endpoint: `/master/${categoryId}`,
      method: "PUT",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  export const EditCategoryDataList = (categoryID) => apiRequest({ endpoint: `/master/edit/${categoryID}` });
  export const ViewCategoryDataList = (categoryID) => apiRequest({ endpoint: `/master/detail/${categoryID}` });

export const getAdminList = async ({  page = 1, searchQuery = "",  selectedCorporate }) => {
    let endpoint = "/list?";
   endpoint += `&page=${page}&searchText=${searchQuery}&corporate_id=${selectedCorporate}`;
  
    return apiRequest({ endpoint, method: "GET" });
  };


  export const addAdmin = async (formData) => {
    return apiRequest({
      endpoint: "/register/",
      method: "POST",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };



  export const updateAdmin = async (adminid, formData) => {
    return apiRequest({
      endpoint: `/update/${adminid}`,
      method: "PUT",
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };
  export const EditAdminDataList = (AdminID) => apiRequest({ endpoint: `/detail/${AdminID}`});
  export const ProductList = (corporateID) => {
    let endpoint = `/product/get/list?status=Active`;
  
    if (corporateID) {
      endpoint = `/product/get/list?status=Active&corporate_id=${corporateID}`;
    }
  
    return apiRequest({
      endpoint: decodeURIComponent(endpoint),
      method: "GET",
    });
  };

  export const sendemailapi = (data) => apiRequest({endpoint: `user/send-email`, headers:{"Content-Type": "Application/json",}, method: "POST", data: data })
  
  

